import styled from 'styled-components';

import { theme } from '../../layout/theme';
import { size, rgba } from '../../layout/helpers';
import { fadeIn, noTransform } from '../../layout/keyframes';

export const MobileMenuWrapper = styled.div`
  position: fixed;
  z-index: ${theme.layers.headerNav};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: ${size(50)};
  background-color: ${theme.colors.bg.main};
  color: ${theme.colors.text.main};
  transform: translateX(-100%);
  animation:
    ${fadeIn} 150ms linear,
    ${noTransform} 150ms ease forwards;

  ${theme.screens.Md} {
    max-width: ${size(68)};
  }
`;

export const MenuHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${size(3)};
  position: absolute;
  z-index: 2;
  width: 100%;
  background-color: ${theme.colors.bg.main};

  &.no-back-button {
    justify-content: flex-end;
  }

  ${theme.screens.Md} {
    padding: 0 ${size(7)};
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: ${theme.colors.text.alt};
  font-size: 1.125rem;

  svg {
    color: ${theme.colors.text.ghost};
  }
`;

export const BackButtonContent = styled.div`
  line-height: 1;

  & + & {
    margin-left: ${size(1)};
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${theme.colors.text.main};
  font-size: 1.125rem;

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${size(5)};
    height: ${size(5)};
    border-radius: 50%;
    background-color: ${rgba(theme.colors.bg.alt, 0.05)};
    opacity: 0;
    transition: opacity 150ms ease;
  }

  &:hover {
    &:before {
      opacity: 1;
    }
  }
`;

export const MenuBody = styled.div`
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  height: 100%;
  padding: ${size(15)} 0 ${size(2)};
`;

const buildLinkAnimationDelay = (): string => {
  let cssString = '';
  for (let i = 1; i < 20; i++) {
    cssString += `
      &.link-${i} {
        animation-duration: ${i * 50}ms;
      }
    `;
  }

  return cssString;
};

export const Link = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: ${size(1.5)} ${size(3)};
  font-size: 1.125rem;
  width: 100%;
  text-align: left;
  transform: translateX(${size(-2)});
  animation:
    ${fadeIn} 50ms linear,
    ${noTransform} 50ms linear forwards;

  &:hover {
    text-decoration: none;
  }

  &.ghost {
    color: ${theme.colors.text.ghost};
  }

  ${buildLinkAnimationDelay()}

  svg {
    font-size: 24px;
  }

  ${theme.screens.Md} {
    padding: ${size(2)} ${size(7)};
  }
`;

export const LinkLabel = styled.div`
  flex: 1 1 auto;
`;

export const LinkIcon = styled.div`
  flex-shrink: 0;
  padding-left: ${size(2)};
  font-size: 1rem;
`;

export const LinkList = styled.div`
  margin-top: ${size(2)};

  &.main {
    ${Link} {
      font-size: 1.5rem;
      font-weight: 600;
    }
  }

  &.heading-list {
    ${Link} {
      font-weight: 600;
    }
  }

  &.tertiary {
    ${Link} {
      color: ${theme.colors.text.alt};
    }
  }
`;

export const UiBlock = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${rgba(theme.colors.bg.alt, 0.1)};
  animation: ${fadeIn} 150ms ease;
  z-index: ${theme.layers.headerNavUiBlock};
`;
